import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type TemplateStat = {
  key: string;
  labelKey: string;
  value: number;
};

type EmailTemplateListStatsProps = {
  stats: TemplateStat[];
};

export const EmailTemplateListStats: FC<EmailTemplateListStatsProps> = ({ stats }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='grid gap-4 rounded-2xl border border-secondary-border bg-white p-4 sm:grid-cols-2'>
      {stats.map((item) => (
        <div key={item.key} className='space-y-1'>
          <p className='text-[11px] font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t(item.labelKey)}</p>
          <p className='text-2xl font-semibold text-slate-900'>{item.value}</p>
        </div>
      ))}
    </div>
  );
};
